import React from 'react';
import InternalContainer from '../../layout/containers/Internal';
import { connect } from 'react-redux';
import Reminders from '../components/NotificationsList/content/Reminders';
import NotificationsContent from '../components/NotificationsList/content/NotificationsContent';
import Announcements from '../components/NotificationsList/content/Announcements';
import InternalTabs from '../../layout/components/InternalTabs/InternalTabs';

const TAB_NAME = 'notificationTabs';

const Notifications = ({ dashboard }) => {
  return (
    <InternalContainer title="Notifications">
      <InternalTabs
        id={TAB_NAME}
        tabs={[
          {
            title: 'Reminders',
            content: <Reminders />,
          },
          {
            title: 'Notifications',
            content: <NotificationsContent notifications={dashboard.stats} />,
          },
          {
            title: 'Announcements',
            content: <Announcements />,
          },
        ]}
      />
    </InternalContainer>
  );
};

export default connect((state) => ({
  dashboard: state.dashboard,
}))(Notifications);
